enum ButtonSizes {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

export { ButtonSizes };
